import { Component, signal, inject, PLATFORM_ID } from '@angular/core';
import {
  RouterOutlet,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { LoadingOverlayService } from './shared/components/loading-overlay/loading-overlay.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import { HealthCheckService } from './core/services/core/health-check.service';
import { MaintenanceComponent } from './shared/components/maintenance/maintenance.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SeoService } from './core/services/shared/seo.service';
import { AnalyticsService } from './core/services/shared/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, MaintenanceComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('SegerYachts.UI');

  public health = inject(HealthCheckService);
  public isAtAdminPage = signal<boolean>(false);
  private platformId = inject(PLATFORM_ID);
  private seo = inject(SeoService);
  private analytics = inject(AnalyticsService);

  constructor(
    private router: Router,
    private loadingService: LoadingOverlayService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isAtAdminPage.set(event.url.startsWith('/admin'));
        this.analytics.clearPage();
        // Show loading starting after a tiny delay to avoid flashing on instant loads
        if (isPlatformBrowser(this.platformId)) {
          this.loadingService.show('Loading...');
        }
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        if (isPlatformBrowser(this.platformId)) {
          this.loadingService.hide();
        }
        if (event instanceof NavigationEnd) {
          const isProductPage = /^\/(boats|merchandise)\/\d+(?:\/|[?#]|$)/.test(event.urlAfterRedirects);
          if (!isProductPage) {
            this.seo.applyRoute(event.urlAfterRedirects);
            this.analytics.trackPageView(event.urlAfterRedirects);
          }
        }
      }
    });
  }
}
